var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMdiTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "MDI_twitter",
    "data-name": "MDI / twitter",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Boundary",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 16,
    height: 16,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_twitter",
    "data-name": "Path / twitter",
    d: "M16.358,5.417a6.069,6.069,0,0,1-1.743.489A3.045,3.045,0,0,0,15.948,4.22a6.121,6.121,0,0,1-1.927.744A2.992,2.992,0,0,0,11.782,4,3.035,3.035,0,0,0,8.758,7.039a3.158,3.158,0,0,0,.078.694A8.638,8.638,0,0,1,2.574,4.56,3.027,3.027,0,0,0,3.516,8.6,3.005,3.005,0,0,1,2.135,8.25v.021a3.041,3.041,0,0,0,2.437,2.982A2.979,2.979,0,0,1,3.2,11.3a3.032,3.032,0,0,0,2.833,2.111,6.036,6.036,0,0,1-3.775,1.3,6.178,6.178,0,0,1-.722-.043A8.644,8.644,0,0,0,14.85,7.393c0-.135,0-.262-.007-.4A6.072,6.072,0,0,0,16.358,5.417Z",
    transform: "translate(-0.123 -1.167)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiTwitter);
export default __webpack_public_path__ + "static/media/MDI - twitter.655d1bd7e1b093ea8a4268afd64ca9bc.svg";
export { ForwardRef as ReactComponent };